import React from "react";
import { Helmet } from "react-helmet";
import { Task } from "../models/Task";
import { generateSlug } from "../utils/TaskUtils";

export default function TaskHelmet({ task }: { task: Task }) {
  return (
    <Helmet>
      <title>{task.title}</title>
      <meta
        property="og:type"
        content="website"
      />
      <meta
        property="og:site_name"
        content="Code on the Rocks"
      />
      <meta
        property="og:image"
        content={task.image_url ?? "https://cotr.dev/logo512.png"}
      />
      <meta
        property="og:url"
        content={`https://cotr.dev/snippet/${task.id}/${generateSlug(
          task.title ?? ""
        )}`}
      />
      <meta
        name="twitter:title"
        property="og:title"
        itemProp="name"
        content={task.title}
      />
      <meta
        name="twitter:card"
        content="summary"
      />
      <meta
        name="twitter:domain"
        content="cotr.dev"
      />
      <meta
        name="twitter:description"
        property="og:description"
        itemProp="description"
        content={task.description?.substring(0, 200)}
      />
      <meta
        property="og:image"
        content="https://cotr.dev/logo512.png"
      />
      <title>{task.title}</title>
      <meta
        name="description"
        content={task.description?.substring(0, 200)}
      />
    </Helmet>
  );
}
